export default {
  "HitPaw Online Audio Joiner": "HitPaw Онлайн Аудио Объединитель",
  "Merge Audio": "Объединить аудио",
  "Merge multiple audio tracks into one.": "Объедините несколько звуковых дорожек в одну.",
  "Merge New": "Объединить Новые",
  "Merge failed": "Слияние не удалось",
  "Fade in": "Постепенно нарастать",
  "Fade out": "Постепенно затухать",
  "Add tracks": "Добавить треки",
  "Format": "Формат",
};
